<template>
  <div class="video-panel">
    <div class="video-box" v-show="!isError">
      <video
        :id="id"
        class="video-js vjs-default-skin vjs-big-play-centered"
        preload="auto"
        width="100%"
        :poster="options.poster === undefined ? defaultPoster : options.poster"
        loop
      >
        <source v-for="el in options.source" :src="el.src" type="video/mp4" />
        <p class="vjs-no-js">不支持播放</p>
      </video>
    </div>
    <div v-show="isError" class="error-tip">视频出错了！</div>
  </div>
</template>
<script>
import { randomName } from '@fe/utils';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import video_zhCN from 'video.js/dist/lang/zh-CN.json';
import defaultPoster from '../assets/img/fileicon/video.png';
export default {
  computed: {
    id() {
      return randomName();
    }
  },
  props: {
    options: {
      required: false,
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      defaultPoster,
      isError: false,
      player: null
    };
  },
  mounted() {
    this.init();
  },
  unmounted() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    init() {
      const defaultOptions = {
        // sources: [
        //   { src: '../../../assets/img/dddd.mp4', type: 'video/mp4' },
        //   { src: '../../../assets/img/dddd.mp4', type: 'video/webm' }
        // ],
        // autoplay: true,
        // 是否显示播放按钮
        bigPlayButton: true,
        playbackRates: [0.5, 1, 1.5, 2],
        controls: true,
        // 设置小喇叭音量键
        controlBar: {
          fullscreenToggle: true,
          // 音量条的横向还是纵向显示
          volumePanel: {
            inline: false
          }
        }
      };
      videojs.addLanguage('zh-CN', video_zhCN);
      const dom = document.getElementById(this.id);

      this.player = videojs(dom, { ...defaultOptions, ...this.options }, () => {
        this.player.on('play', () => {
          console.log('开始播放');
        });
      });
    },
    onPaly() {
      if (this.player) {
        // 播放并打开声音
        this.player.play();
        this.player.muted(false);
      }
    },
    onStop() {
      if (this.player) {
        this.player.pause();
        // this.player.currentTime(0); // 下次从头播放
        this.player.initChildren(); // 显示wyyt初始界面
      }
    }
  }
};
</script>
<style lang="postcss">
.video-panel {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  .video-box {
    width: 100%;
    height: 100%;
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .video-js {
      width: 100%;
      height: 100%;
    }
  }
  .error-tip {
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background: #000000;
    text-align: center;
  }

  .video-js .vjs-big-play-button {
    line-height: 1.5em;
    height: 1.5em;
    width: 1.5em;
    border-radius: 50%;
    margin-top: -0.75em;
    margin-left: -0.75em;
    border: 1px solid #f9f9f9;
  }
}
</style>
